import { FC, memo } from 'react';
import Tasks from '../../components/Tasks/Tasks';
import { useTasksScreen } from '../../hooks/screens/useTasksScreen';

const TasksScreen: FC = memo(() => {
  const props = useTasksScreen();
  return <Tasks {...props} />;
});

TasksScreen.displayName = 'TasksScreen';
export default TasksScreen;
